import { Slot } from "@radix-ui/react-slot";
import classNames from "classnames";
import React, { forwardRef } from "react";

import { ODSText } from "../ODSText";
import { ODSBreadcrumbMenuItemProps } from "./ODSBreadcrumb.types";

import "./css/index.css";

const ODSBreadcrumbMenuItem = forwardRef<
  HTMLAnchorElement,
  ODSBreadcrumbMenuItemProps
>(({ className, text, asChild, children, ...rest }, ref) => {
  const Comp = asChild ? Slot : "a";

  return (
    <Comp
      ref={ref}
      className={classNames(`ODSBreadcrumbMenuItem`, className)}
      {...rest}
    >
      {asChild ? (
        children
      ) : (
        <ODSText as="span" className="ODSBreadcrumbMenuItem-Label">
          {text}
        </ODSText>
      )}
    </Comp>
  );
});

ODSBreadcrumbMenuItem.displayName = "ODSBreadcrumbMenuItem";

export default ODSBreadcrumbMenuItem;
